module.exports = "/_next/static/images/page-header-1-1-dea7ffe2c4c366d8111e0765bef695f6.jpg";